import React from 'react';
import { Controller } from 'react-hook-form';

const InputField = ({
  name,
  control,
  rules,
  placeholder,
  type = 'text',
  maxLength,
  disabled = false,
  customOnChange,
  customOnBlur,
}) => (
  <Controller
    name={name}
    control={control}
    defaultValue=''
    rules={rules}
    render={({ field, fieldState: { error } }) => (
      <div className='form-group'>
        <label htmlFor={name}>{placeholder}</label>
        <input
          type={type}
          placeholder={placeholder}
          {...field}
          maxLength={maxLength}
          disabled={disabled}
          className={error ? 'input-error' : ''}
          onChange={(e) => {
            const value = e.target.value;
            if (customOnChange) {
              customOnChange(e, field);
            } else {
              field.onChange(value);
            }
          }}
          onBlur={(e) => {
            if (customOnBlur) {
              customOnBlur(e, field);
            }
          }}
        />
        {error && <p className='error-msg'>{error.message}</p>}
      </div>
    )}
  />
);

export default InputField;
